module.exports = __webpack_public_path__ + "static/media/add-user-icon.959c74ff.png";